import { useState } from 'react';
import { DiningModalProps, UseDiningModalParams } from '@msc-b2c/interfaces/interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '@msc-b2c/shared-utils';

export const useDiningModal = (): UseDiningModalParams => {
  const [modal, setModal] = useState<DiningModalProps | undefined>(undefined);

  const errorManager = useSelector((state: RootState) => state.errorManager);
  const errorManagerCode = errorManager?.errorManagerCode;

  const openModal = (data: DiningModalProps) => {
    if (modal?.show || !!errorManagerCode) return;
    if (!data?.title || !data?.description) return;

    setModal({ ...data, show: true });
  };

  const closeModal = () => setModal(undefined);

  return { modal, openModal, closeModal };
};
